import IconBase from './icon-base';

const IconChevronRight = ({ className, color = 'black', height, hoverColor, width }) => (
  <IconBase className={className} viewBox="0 0 9 15" width={width} height={height} hoverColor={hoverColor}>
    <path
      d="M0.5 0.5L8.5 7.43531L0.5 14.5048"
      stroke={color}
      fill="transparent"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export default IconChevronRight;
